// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "./vendor/some-package.js"
//
// Alternatively, you can `npm install some-package` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html";
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";

// const ReachEventObserver = new IntersectionObserver((entries) => {
//   for (let entry of entries) {
//     if (entry.isIntersecting) {
//       gtag("event", `Reach ${entry.target.dataset.point}`, {
//         event_category: entry.target.dataset.category,
//       });
//       ReachEventObserver.unobserve(entry.target);
//     }
//   }
// });

let formToolsAreInstalled = false;
function installToolsJS() {
  return new Promise((resolve) => {
    if (formToolsAreInstalled) resolve(true);
    formToolsAreInstalled = true;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://forms.mariedenazareth.com/scripts/tools.js";
    script.addEventListener("load", function () {
      resolve(true);
    });
    document.body.appendChild(script);
  });
}

const Hooks = {
  Main: {
    mounted() {
      this.handleEvent("scroll-to-top", () => window.scrollTo(0, 0));
    },
  },
  // ReachEvent: {
  //   mounted() {
  //     ReachEventObserver.observe(this.el);
  //   },
  // },
  SubscriptionForm: {
    mounted() {
      const el = this.el;

      async function createForm() {
        await installToolsJS();
        const iframe = document.createElement("iframe");
        iframe.src =
          "https://forms.mariedenazareth.com/__YVZaqvoQBjQk8CJjOCgcZ?origin=FR-SITJA-ABOJA";
        iframe.title = "Formulaire d'abonnement à Jésus Aujourd'hui";
        iframe.dataset.autoResize = "true";
        iframe.dataset.minHeight = "150";
        iframe.className = "w-full mb-4";
        el.appendChild(iframe);
      }
      function checkVisibility() {
        if (el.offsetParent === null) {
          window.requestAnimationFrame(checkVisibility);
        } else {
          createForm();
        }
      }
      checkVisibility();
    },
  },
};

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");
let liveSocket = new LiveSocket("/live", Socket, {
  params: { _csrf_token: csrfToken },
  hooks: Hooks,
});

// Connect if there are any LiveViews on the page
liveSocket.connect();

// Expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)
// The latency simulator is enabled for the duration of the browser session.
// Call disableLatencySim() to disable:
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;
